import { FC } from 'react'
import styled from 'styled-components'
import ErrorIcon from 'svgIcons/ErrorIcon'

const CommunityScrapDeletedRow: FC = () => {
  return (
    <StyledWrapper>
      <ErrorIcon />
      <span>글쓴이가 삭제한 글입니다.</span>
    </StyledWrapper>
  )
}

export default CommunityScrapDeletedRow

const StyledWrapper = styled.div`
  display: flex;
  color: #cccccc;

  span {
    margin-left: 6px;
  }
`
